<script setup lang="ts">
import type { Schemas } from '@shopware/api-client/api-types/storeApiTypes';

const props = defineProps<{
    block: Schemas['CmsBlock'];
}>();

const { getSlotContent } = useCmsBlock(props.block);

const config = getSlotContent('config') as Schemas['CmsSlot'];
</script>

<template>
    <CmsLoader :content="config" />
</template>
